import axios from 'axios';
import actionHelpers from '../../utils/action-helpers';
import mutationHelpers from '../../utils/mutation-helpers';
// import { getCookie } from '../../utils/helpers';

const path = process.env.VUE_APP_ROOT_API;

axios.defaults.baseURL = path;

const state = {
  status: null,
  users: [],
  errors: [],
  activity: []
};

// getters
const getters = {};

// actions
const actions = {
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
  REGISTER_USER: async ({ commit, dispatch }, { user }) => {
    try {
      // console.log('user', user);
      const res = await axios.post(`${path}/api/register`, { user });
      // console.log('res', res);
      dispatch(
        'currentUser/LOGIN',
        { email: user.email, password: user.password },
        { root: true }
      );

      return res;
      // login user
    } catch (error) {
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'registration was unsuccessful. try again later.',
        { root: true }
      );
    }
  }
};

// mutations
const mutations = {
  UPDATE_STATUS: mutationHelpers.UPDATE_STATUS,
  RESET_ERRORS: mutationHelpers.RESET_ERRORS,
  SET_ERROR: mutationHelpers.SET_ERROR
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
